import axios from "axios";
import { useDataProvider } from "react-admin";
import { userService } from "../services/UserService";

/**
 *
 * @typedef {"portalApi" | "masterDataApi" | "telemetryApi" | "calibrationPlatformApi" | "deviceUtilityApi"} ApiName
 */

function useSimpleDataProvider() {
    const dataProvider = useDataProvider();

    /**
     *
     * @param {ApiName} apiName
     * @param {*} path
     */
    const getByUrl = async (apiName, path) => {
        if (apiName in window.env) {
            const host = window.env[apiName];

            let headers = {
                Authorization: `${userService.getAuthToken()}`,
                "Content-Type": "application/json",
            };

            const response = await axios.get(`${host}/${path}`, { headers });

            return response.data;
        } else {
            throw Error("Invalid apiName parameter of ", apiName, "Check public/env.js for valid apiNames");
        }
    };

    const getOne = async (resource, options) => {
        try {
            const response = await dataProvider.getOne(resource, options);
            return response.data;
        } catch (error) {
            console.error(`Failed to fetch data for resource ${resource}`, error);
            throw error;
        }
    };

    const getAll = async (resource, filter = {}, sort = null) => {
        try {
            const options = {
                pagination: { page: 1, perPage: 1000000 },
                sort: { field: "id", order: "ASC" },
                filter: filter,
            };

            const response = await dataProvider.getMany(resource, options);

            return response.data;
        } catch (error) {
            console.error(`Failed to fetch data for resource ${resource}`, error);
            throw error;
        }
    };

    const getMany = async (resource, filter = {}) => {
        const options = {
            pagination: { page: 1, perPage: 1000000 },
            sort: { field: "id", order: "ASC" },
            filter: filter,
        };
        try {
            const response = await dataProvider.getMany(resource, options);
            return response.data;
        } catch (error) {
            console.error(`Failed to fetch data for resource ${resource}`, error);
            throw error;
        }
    };

    return {
        getOne,
        getMany,
        getAll,
        getByUrl,
        CLIENTS: "clients",
    };
}

export default useSimpleDataProvider;
